import { render, staticRenderFns } from "./CrftEditAbout.vue?vue&type=template&id=3d386a0c&scoped=true&"
import script from "./CrftEditAbout.vue?vue&type=script&lang=js&"
export * from "./CrftEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d386a0c",
  null
  
)

export default component.exports